<template>
  <section class="section-five">
    <div class="section-one__title">Overview mercato {{ infocar.marca }} {{ infocar.modello }}</div>
    <div class="section-five--wrapper">
      <div class="section-title-box">
        <div class="section-box">
          <span class="section-box__title">Totale veicoli</span>
          <span class="section-box__number">{{ geo.totale }}</span>
          <span class="qrt-icon-location"
            ><span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="white"
                class="bi bi-geo-alt"
                viewBox="0 0 16 16"
              >
                <path
                  d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10"
                />
                <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
              </svg> </span
          ></span>
        </div>
        <div class="section-title">
          <div class="section-top-title">
            <span class="title">Geolocalizzazione veicoli: CAP {{ geo.cap }}</span>
            <div class="iconTooltip__container" @click="toggleTooltip">
              <span class="qrt-icon-Icona_Information">
                <img
            src="../../../images/project-img/Icon-information-circle.png"
            alt="info icon"
            width="20px"
          />
              </span>
              <div class="tooltip" :class="{ 'tooltip-visible': tooltipVisible }">
                Meno auto ci sono nella tua zona più alto potresti tenere il prezzo! Attenzione però
                alle alternative.
              </div>
            </div>
          </div>
          <span class="text-two">
            L'overview di mercato fornisce una vista immediata sull'insieme dei veicoli e la loro
            distribuzione sul territorio nazionale nell'intorno del CAP indicato. Nell'analisi sono
            considerati gli annunci del veicolo selezionato indipendentemenete dalla tipologia di
            allestimento, chilometraggio, prezzo di vendita o anno di immatricolazione.
          </span>
        </div>
      </div>
      <div class="section-five--bottom__wrapper">
        <div class="section-five--bottom">
          <div class="section-five--flag section-five--flag__one">
            <div class="flag-one">
              <span>{{ geo.scaglioni['50'].count }}</span>
              auto
            </div>
            <div class="flag-two">
              <div class="flag-two-up">Prezzo medio</div>
              <div class="flag-two-down">
                <b>{{ formatNumber(geo.scaglioni['50'].media) }}</b> €
              </div>
            </div>
            <div class="flag-three"></div>
          </div>
          <div class="section-five--flag section-five--flag__two">
            <div class="flag-one">
              <span>{{ geo.scaglioni['100'].count }}</span>
              auto
            </div>
            <div class="flag-two">
              <div class="flag-two-up">Prezzo medio</div>
              <div class="flag-two-down">
                <b>{{ formatNumber(geo.scaglioni['100'].media) }}</b> €
              </div>
            </div>
            <div class="flag-three"></div>
          </div>
          <div class="section-five--flag section-five--flag__three">
            <div class="flag-one">
              <span>{{ geo.scaglioni['150'].count }}</span>
              auto
            </div>
            <div class="flag-two">
              <div class="flag-two-up">Prezzo medio</div>
              <div class="flag-two-down">
                <b>{{ formatNumber(geo.scaglioni['150'].media) }}</b> €
              </div>
            </div>
            <div class="flag-three"></div>
          </div>
          <div class="section-five--flag section-five--flag__four">
            <div class="flag-one">
              <span>{{ geo.scaglioni['200'].count }}</span>
              auto
            </div>
            <div class="flag-two">
              <div class="flag-two-up">Prezzo medio</div>
              <div class="flag-two-down">
                <b>{{ formatNumber(geo.scaglioni['200'].media) }}</b> €
              </div>
            </div>
            <div class="flag-three"></div>
          </div>
          <span class="lap"></span>
          <span class="lap"></span>
          <span class="lap"></span>
          <span class="lap"></span>
          <span class="lap"></span>
          <span class="lap"></span>
          <span class="lap"></span>
          <span class="lap"></span>
          <span class="lap"></span>
          <span class="lap"></span>
          <span class="lap"></span>
          <span class="lap"></span>
          <span class="lap"></span>
          <span class="lap"></span>
          <span class="lap"></span>
          <span class="lap"></span>
          <span class="lap"></span>
          <span class="lap"></span>
          <span class="lap"></span>
          <span class="lap"></span>
        </div>
        <div class="section-five-axis">
          <span class="axis--element__one">Raggio</span>
          <span class="axis--element__two">50 km</span>
          <span class="axis--element__three">100 km</span>
          <span class="axis--element__four">150km</span>
          <span class="axis--element__five">200km</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LivemarketDataOverview',
  data() {
    return {
      tooltipVisible: false,
    };
  },
  props: {
    geo: {
      type: Object,
      required: true,
    },
    infocar: {
      type: Object,
      required: true,
    },
  },
  methods: {
    toggleTooltip() {
      this.tooltipVisible = !this.tooltipVisible;
    },
    formatNumber(value) {
      if (value === null || value === undefined) {
        return '';
      }
      const parts = value.toString().split('.');
      // Format the integer part with dots as thousands separators
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return parts.join('.');
    },
  },
};
</script>

<style scoped>
.section-five {
  padding: 77px 0px 41px;
  margin: 0px 100px;
  border-top: 2px solid #d20a11;
  position: relative;
}
.section-one__title {
  color: #ffffff;
  background-color: #d20a11;
  padding: 0px 25px;
  height: 33px;
  width: max-content;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  text-transform: uppercase;
  font-weight: bold;
  font-size: 18px;
  line-height: 56px;
  letter-spacing: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.section-five--wrapper {
  max-width: 830px;
  width: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
}
.section-title-box {
  display: flex;
}
.section-box {
  position: relative;
  width: 152px;
  height: 110px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  margin-right: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.section-box__title {
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0px;
  color: #333333;
}
.section-box__number {
  font-size: 48px;
  line-height: 62px;
  letter-spacing: 0px;
  color: #707070;
}
.section-box .qrt-icon-location {
  font-size: 32px;
  position: absolute;
  bottom: -10px;
  background-color: rgb(204, 204, 204);
  padding: 5px;
  border-radius: 5px;
}
.section-five .section-title {
  flex: 1;
}
.section-title {
  display: flex;
  flex-direction: column;
}
.section-top-title {
  display: flex;
  justify-content: space-between;
}
.section-top-title .title {
  color: #d20a11;
  font-size: 21px;
  line-height: 28px;
  font-weight: bold;
}
.iconTooltip__container {
  position: relative;
}
.iconTooltip__container .tooltip {
  visibility: hidden;
  width: 198px;
  padding: 20px 5px;
  background-color: #fff;
  color: #333;
  text-align: center;
  position: absolute;
  z-index: 1;
  bottom: 130%;
  left: -30px;
  margin-left: -60px;
  box-shadow: 0px 0px 6px #00000045;
  display: flex !important;
  justify-content: center;
  align-items: center;
  font-weight: 300;
}
.iconTooltip__container .tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #fff transparent transparent transparent;
}
.iconTooltip__container .tooltip-visible {
  visibility: visible;
}

.text-two {
  font-size: 0.875rem;
  line-height: 18px;
  margin-top: 5px;
}
.section-five--bottom__wrapper {
  width: 100%;
  overflow: auto;
  white-space: nowrap;
  scrollbar-width: none;
}
.section-five--bottom {
  display: flex;
  position: relative;
  margin-top: 125px;
  width: 830px;
}
.section-five--flag {
  background-color: #d20a11;
  color: #ffffff;
  max-width: 95px;
  width: 100%;
  position: absolute;
  bottom: 13px;
}
.section-five--flag__one {
  left: 114px;
}
.flag-one {
  text-align: center;
  font-size: 12px;
  padding: 7px 0px;
  border-bottom: 1px solid #ffffff;
  margin: 0px 5px;
}
.flag-one span {
  font-size: 18px;
  font-weight: bold;
}
.flag-two {
  text-align: center;
  padding: 7px 0px 10px;
  margin: 0px 5px;
}
.flag-two-up {
  font-size: 12px;
  margin-bottom: 4px;
}
.flag-two-down {
  font-size: 18px;
}
.flag-two-down b {
  font-weight: bold;
}
.flag-three {
  height: 13px;
  background-color: #ffffff;
  border-right: 2px solid #d20a11;
}
.section-five--flag__two {
  left: 322px;
}
.section-five--flag__three {
  left: 529px;
}
.section-five--flag__four {
  right: 3px;
}
.section-five--bottom .lap {
  width: 40px;
  height: 13px;
  background-color: #e8e8e8;
  margin-left: 2px;
}
.section-five-axis {
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-top: 9px;
  width: 830px;
  color: #aaaaaa;
  font-size: 14px;
  line-height: 19px;
}
.axis--element__one {
  font-weight: bold;
}
.axis--element__two {
  position: absolute;
  left: 170px;
}
.axis--element__three {
  position: absolute;
  left: 375px;
}
.axis--element__four {
  position: absolute;
  left: 585px;
}
@media (max-width: 768px) {
  .section-five {
    border-bottom: 2px solid #e4e4e4;
    margin-bottom: 23px;
    padding: 58px 0px 36px;
    display: flex;
    justify-content: center;
  }
  .section-five .section-one__title {
    font-size: 11px;
  }
  .section-title-box {
    flex-direction: column;
  }
  .section-box {
    width: 100%;
    margin-left: 0px;
    margin-top: 24px;
    margin-bottom: 18px;
  }
  .iconTooltip__container .tooltip {
    left: -110px;
  }
  .iconTooltip__container .tooltip::after {
    left: 75%;
  }
}
@media (max-width: 600px) {
  .section-five {
    padding: 46px 0px 36px;
    margin: 0px 17px 23px;
  }
  .section-five--wrapper {
    position: relative;
  }
  .iconTooltip__container .tooltip::after {
    left: auto;
    right: 15px;
  }
  .section-five--wrapper::after {
    content: '';
    position: absolute;
    right: -10px;
    width: 40px;
    height: 38%;
    bottom: 0;
    background: linear-gradient(to left, #fff 30%, transparent 100%);
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/LivemarketDataOverview.vue